import request from '@/utils/request'
const root = '/crmFinanceApplication'
export const financeOptions = () => request({ url: root + '/options' })
export const invoiceDefaults = contractId => request({ url: root + '/invoiceDefaults', params: { contractId } })
export const financeContracts = params => request({ url: root + '/contracts', params })
export const financeList = params => request({ url: root + '/list', params })
export const financeDetail = id => request({ url: root + '/detail/' + id })
export const financeSave = data => request({ url: root + '/save', method: 'post', data })
export const financeSubmit = data => request({ url: root + '/submit', method: 'post', data })
export const financeWithdraw = data => request({ url: root + '/withdraw', method: 'post', data })
export const financeHandle = data => request({ url: root + '/handle', method: 'post', data })
export const savePaymentInvoices = data => request({ url: root + '/paymentInvoices', method: 'post', data })

export const financeApprovalPreview = data => request({url:root+"/approval-preview",method:"post",data})
